export function formatMetric(value, type) {
  if (value === null || value === undefined) return '—';
  switch (type) {
    case 'currency':
      return '€' + Number(value).toLocaleString('it-IT', {
        minimumFractionDigits: 2, maximumFractionDigits: 2,
      });
    case 'percent':
      return Number(value).toLocaleString('it-IT', {
        minimumFractionDigits: 2, maximumFractionDigits: 2,
      }) + '%';
    case 'number':
    default:
      return Number(value).toLocaleString('it-IT');
  }
}
